module.exports = __webpack_public_path__ + "img/pbtc_btc.ptokens.2050e49.png";